import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { ImageBanner } from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';

interface CmsFile {
  src: string;
  target_id?: string;
}

interface CmsImage extends CmsFile {
  alt: string;
  title?: string;
  width?: string;
  height?: string;
}

@Component({
  selector: 'digital-platform-image-banner-ptype',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-banner.component.html',
  styleUrls: ['./image-banner.component.scss'],
})
export class ImageBannerPTypeComponent
  extends BasePTypeComponent
  implements ImageBanner
{
  public override type = 'imageBanner' as const;

  public backgroundImage: CmsImage = {
    src: 'https://via.placeholder.com/700x500.png',
    alt: 'Image Banner',
  };
  public borderless = false;
  public title = 'Image Banner';
  public containerType = 'row';

  private _backgroundPosition = 'center';
  private _backgroundSize = '1024';
  private _imageBackgroundClass = 'image-banner';
  private _verticalAlign = '';

  public get backgroundImageSrc(): string {
    return `url('${this.backgroundImage?.src}')`;
  }

  public set backgroundPosition(value: string) {
    this._backgroundPosition = value;
  }
  public get backgroundPosition(): string {
    return this._backgroundPosition ?? '';
  }

  public set backgroundSize(value: string) {
    this._backgroundSize = value;
  }
  public get backgroundSize(): string {
    return this._backgroundSize ?? '';
  }

  public set imageBackgroundClass(value: string) {
    this._imageBackgroundClass = value;
  }
  public get imageBackgroundClass(): string {
    return this._imageBackgroundClass ?? '';
  }

  public set verticalAlign(value: string) {
    this._verticalAlign = value;
  }
  public get verticalAlign(): string {
    return this._verticalAlign ?? 'middle';
  }
}
